import WebFont from 'webfontloader';
import { WEBFONT_CONFIG } from './constants';

WebFont.load(WEBFONT_CONFIG);
